import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { BaseConstants } from '../constants';
import { environment } from 'environments/environment';

@Injectable()
export class ConfigProvider {

    private config: any = null;

    constructor(private http: HttpClient) { }

    public getConfig(key: any) {
        return this.config[key];
    }

    public load() {
        return new Promise((resolve, reject) => {
            const options = {
                headers: new HttpHeaders({
                    noToken: 'noToken'
                })
            };
            this.http.get('./assets/data/app.config.json', options)
                .catch((error: any) => {
                    reject();
                    return Observable.throw(error.json().error || 'Server error');
                })
                .subscribe((responseData: any) => {
                    console.log('configuration:'+responseData.configuration);
                    console.log("baseurl:"+environment.baseUrl);
                    this.config = responseData.configuration;
                    BaseConstants.baseUrl = environment.baseUrl;
                    BaseConstants.appConfig = this.config;
                    BaseConstants.digitalSignageConfig = responseData.digitalConfig;
                    resolve(true);
                });
        });

    }
}
